export default __webpack_public_path__ + "static/media/3d_card1.bcd7a679.png";